import type { GeoPointJSON } from '@ikegps/core-api';

export class PointCacheImpl {
	cache: { [key: string]: google.maps.Point } = {};
	projection: google.maps.MapCanvasProjection = null;

	reset() {
		this.cache = {};
	}

	setProjection(projection: google.maps.MapCanvasProjection) {
		this.projection = projection;
	}

	getGeoPoint(loc: GeoPointJSON): google.maps.Point {
		return this.getPoint(loc.coordinates[1], loc.coordinates[0]);
	}

	getPoint(lat: number, lng: number): google.maps.Point {
		var cacheKey = `${lat}:${lng}`;
		var point = this.cache[cacheKey];
		if (this.projection == null) {
			return null;
		}

		if (point == null && this.projection != null) {
			var latLng = new google.maps.LatLng(lat, lng);
			point = this.cache[cacheKey] = this.projection.fromLatLngToDivPixel(latLng);
		}

		return point;
	}
}

export const PointCache = new PointCacheImpl();
